/* Complete PDP — audience doors, extra strips add-to-cart, outcomes sync.
   Built 2026-09-07. Depends on theme globals: routes, fetchConfig, publish, PUB_SUB_EVENTS. */
(function () {
  if (window.__cpdpInit) return; window.__cpdpInit = true;
  var KEYS = [];
  document.querySelectorAll('[data-door]').forEach(function (b) { var k = b.getAttribute('data-door'); if (KEYS.indexOf(k) < 0) KEYS.push(k); });
  if (!KEYS.length) KEYS = ['curious', 'pregnancy', 'irregular'];
  var STORE = 'cpdp_door:' + location.pathname;
  var current = null;

  function dl(ev, data) {
    window.dataLayer = window.dataLayer || [];
    var o = { event: ev };
    for (var k in data) o[k] = data[k];
    window.dataLayer.push(o);
  }
  function fromUrl() {
    var h = (location.hash || '').replace('#', '');
    if (KEYS.indexOf(h) > -1) return h;
    var p = new URLSearchParams(location.search).get('for');
    if (KEYS.indexOf(p) > -1) return p;
    return null;
  }
  function stored() {
    try { var v = sessionStorage.getItem(STORE); return KEYS.indexOf(v) > -1 ? v : null; } catch (e) { return null; }
  }
  function slideGallery(idx) {
    if (!idx) return;
    var wrap = document.querySelector('.product__media-wrapper');
    if (!wrap) return;
    var els = wrap.querySelectorAll('.swiper');
    for (var i = 0; i < els.length; i++) {
      var sw = els[i].swiper;
      if (sw && sw.slides && sw.slides.length > 1) {
        try { (sw.params && sw.params.loop) ? sw.slideToLoop(idx - 1) : sw.slideTo(idx - 1); } catch (e) {}
        return;
      }
    }
  }
  function setDoor(key, source) {
    if (KEYS.indexOf(key) < 0) return;
    var changed = key !== current;
    current = key;
    // door buttons + panels
    document.querySelectorAll('[data-door]').forEach(function (b) {
      var on = b.getAttribute('data-door') === key;
      b.setAttribute('aria-selected', on ? 'true' : 'false');
      if (on && b.hasAttribute('data-slide') && source === 'tap') slideGallery(parseInt(b.getAttribute('data-slide'), 10));
    });
    document.querySelectorAll('[data-panel]').forEach(function (p) { p.hidden = p.getAttribute('data-panel') !== key; });
    document.querySelectorAll('[data-quote]').forEach(function (q) { q.hidden = q.getAttribute('data-quote') !== key; });
    // add-on highlight + door-conditional elements
    document.querySelectorAll('[data-cpdp-strips]').forEach(function (s) {
      s.classList.toggle('is-highlight', s.getAttribute('data-highlight') === key);
    });
    document.querySelectorAll('[data-hide-on]').forEach(function (el) { el.hidden = el.getAttribute('data-hide-on').split(',').indexOf(key) > -1; });
    document.querySelectorAll('[data-show-on]').forEach(function (el) { el.hidden = el.getAttribute('data-show-on').split(',').indexOf(key) < 0; });
    // outcomes table
    document.querySelectorAll('[data-door-col]').forEach(function (c) { c.classList.toggle('is-active', c.getAttribute('data-door-col') === key); });
    document.querySelectorAll('[data-outcome-tab]').forEach(function (t) { t.setAttribute('aria-selected', t.getAttribute('data-outcome-tab') === key ? 'true' : 'false'); });
    try { sessionStorage.setItem(STORE, key); } catch (e) {}
    if (changed && source === 'tap') dl('pdp_door_select', { door: key, product: location.pathname.split('/').pop() });
    document.dispatchEvent(new CustomEvent('cpdp:door', { detail: { door: key } }));
  }

  function init() {
    var doors = document.querySelector('[data-cpdp-doors]');
    var start = fromUrl() || stored() || (doors && doors.getAttribute('data-default')) || KEYS[0];
    setDoor(start, 'init');
    dl('pdp_door_view', { door: start, product: location.pathname.split('/').pop(), via: fromUrl() ? 'link' : 'default' });

    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-door],[data-outcome-tab]');
      if (!b) return;
      var key = b.getAttribute('data-door') || b.getAttribute('data-outcome-tab');
      setDoor(key, 'tap');
    });
    window.addEventListener('hashchange', function () { var k = fromUrl(); if (k) setDoor(k, 'link'); });

    // Extra strips checkbox
    document.querySelectorAll('.cpdp-strips__check').forEach(function (cb) {
      cb.addEventListener('change', function () {
        dl('pdp_strips_toggle', { checked: cb.checked, door: current, addon: cb.closest('[data-cpdp-strips]').getAttribute('data-name') || 'strips', product: location.pathname.split('/').pop() });
      });
    });

    // Add-to-cart intercept: when any add-on is ticked, add kit + add-ons in one request.
    var prod = location.pathname.split('/').pop();
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.matches || !form.matches('form[data-type="add-to-cart-form"]')) return;
      var checked = [].slice.call(document.querySelectorAll('[data-cpdp-strips] .cpdp-strips__check:checked'));
      var addons = checked.map(function (cb) { return cb.closest('[data-cpdp-strips]').getAttribute('data-variant'); }).filter(Boolean);
      var names = checked.map(function (cb) { return cb.closest('[data-cpdp-strips]').getAttribute('data-name') || 'strips'; });
      if (!addons.length) {
        dl('pdp_add_to_cart', { source: 'pdp', door: current, product: prod, extra_strips: false, addons: [] });
        return;
      }
      var idEl = form.querySelector('[name="id"]');
      var qtyEl = form.querySelector('[name="quantity"]') || document.querySelector('input[form="' + form.id + '"][name="quantity"]');
      var kitId = idEl && idEl.value;
      var qty = Math.max(1, parseInt(qtyEl && qtyEl.value, 10) || 1);
      if (!kitId) return; // let the theme handle it normally
      e.preventDefault();
      e.stopImmediatePropagation();
      var pf = form.closest('product-form');
      var btn = form.querySelector('[type="submit"]') || (pf && pf.submitButton);
      if (btn && btn.getAttribute('aria-disabled') === 'true') return;
      var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.classList.add('loading'); }
      var items = [ { id: parseInt(kitId, 10), quantity: qty } ];
      addons.forEach(function (id) { items.push({ id: parseInt(id, 10), quantity: 1 }); });
      var body = { items: items };
      if (cart && cart.getSectionsToRender) {
        body.sections = cart.getSectionsToRender().map(function (s) { return s.id; }).join(',');
        body.sections_url = window.location.pathname;
        if (cart.setActiveElement) cart.setActiveElement(document.activeElement);
      }
      var config = (typeof fetchConfig === 'function') ? fetchConfig('javascript') : { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' } };
      config.headers = config.headers || {};
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      config.headers['Content-Type'] = 'application/json';
      config.body = JSON.stringify(body);
      var url = (window.routes && routes.cart_add_url) ? routes.cart_add_url : '/cart/add.js';
      fetch(url, config).then(function (r) { return r.json(); }).then(function (res) {
        if (res.status) {
          if (pf && pf.handleErrorMessage) pf.handleErrorMessage(res.description || res.message);
          if (window.publish && window.PUB_SUB_EVENTS) publish(PUB_SUB_EVENTS.cartError, { source: 'product-form', productVariantId: kitId, errors: res.description, message: res.message });
          return;
        }
        dl('pdp_add_to_cart', { source: 'pdp', door: current, product: prod, extra_strips: names.indexOf('strips') > -1, addons: names, quantity: qty });
        if (!cart) { window.location = (window.routes && routes.cart_url) || '/cart'; return; }
        if (window.publish && window.PUB_SUB_EVENTS) publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: kitId });
        if (cart.renderContents) cart.renderContents(res);
        if (window.applySwiperToCartDrawer) window.applySwiperToCartDrawer();
      }).catch(function (err) { console.error(err); }).finally(function () {
        if (btn) { btn.classList.remove('loading'); btn.removeAttribute('aria-disabled'); }
        if (cart && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
      });
    }, true);
  }

  // Collapsible reviews: wrap the reviews.io widget section in a toggle (expanded via "Read all reviews" links)
  function collapseReviews() {
    var w = document.querySelector('.ElementsWidget-prefix, .ReviewsWidget, [id^="ReviewsWidget"]');
    if (!w) return false;
    var sec = w.closest('.shopify-section');
    if (!sec || sec.getAttribute('data-cpdp-collapsed')) return true;
    sec.setAttribute('data-cpdp-collapsed', '1');
    var wrap = document.createElement('div'); wrap.className = 'cpdp-revwrap';
    while (sec.firstChild) wrap.appendChild(sec.firstChild);
    var doors = document.querySelector('[data-cpdp-doors]');
    var label = (doors && doors.getAttribute('data-reviews')) || 'Customer reviews';
    var head = document.createElement('button'); head.type = 'button'; head.className = 'cpdp-revtoggle'; head.setAttribute('aria-expanded', 'false');
    head.innerHTML = '<span class="cpdp-revtoggle__label"><span class="cpdp-revtoggle__stars" aria-hidden="true">★★★★★</span> ' + label + '</span><span class="cpdp-revtoggle__cta">Read reviews</span>';
    var inner = document.createElement('div'); inner.className = 'container cpdp-revtoggle__wrap'; inner.appendChild(head);
    sec.appendChild(inner); sec.appendChild(wrap); wrap.hidden = true;
    function setOpen(open) { wrap.hidden = !open; head.setAttribute('aria-expanded', open ? 'true' : 'false'); head.querySelector('.cpdp-revtoggle__cta').textContent = open ? 'Hide reviews' : 'Read reviews'; }
    head.addEventListener('click', function () { var open = wrap.hidden; setOpen(open); if (open) dl('pdp_reviews_open', { product: location.pathname.split('/').pop() }); });
    document.addEventListener('click', function (e) { var a = e.target.closest('a[href="#reviews"]'); if (!a) return; e.preventDefault(); setOpen(true); sec.scrollIntoView({ behavior: 'smooth', block: 'start' }); });
    return true;
  }
  function watchReviews() {
    if (collapseReviews()) return;
    var tries = 0; var iv = setInterval(function () { if (collapseReviews() || ++tries > 40) clearInterval(iv); }, 250);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); watchReviews(); }); else { init(); watchReviews(); }
})();
